export default "__VITE_ASSET__5ofo7YTw__"